import React from "react";

export default function ProgressGauge({ value, max = 39, hideAmount = false }) {
    const pct = Math.min(100, (value / max) * 100);
    const reached = value >= max;
    return (
        <div data-testid="progress-gauge" className="w-full">
            <div className="flex items-end justify-between mb-2">
                <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold">
                    Financement maillot
                </span>
                {!hideAmount && (
                    <span className="font-display text-2xl leading-none">
                        {value}€
                        <span className="text-zinc-500 text-base"> / {max}€</span>
                    </span>
                )}
            </div>
            <div className="w-full h-3 bg-zinc-900 border border-zinc-800 overflow-hidden relative">
                <div
                    className="neon-bar"
                    style={{ width: `${pct}%` }}
                />
            </div>
            <div className="mt-2 text-xs">
                {reached ? (
                    <span className="text-orange-500 font-bold uppercase tracking-widest">
                        ✓ Seuil atteint — fabrication possible
                    </span>
                ) : hideAmount ? (
                    <span className="text-zinc-400 uppercase tracking-widest text-[11px]">
                        Collecte en cours…
                    </span>
                ) : (
                    <span className="text-zinc-400">
                        Encore <span className="text-orange-500 font-bold">{max - value}€</span> avant fabrication
                    </span>
                )}
            </div>
        </div>
    );
}
